import angular from "angular";

export default function (appName: string) {
	angular.bootstrap(document.documentElement, [appName], {
		strictDi: true
	});
}
